// extracted by mini-css-extract-plugin
module.exports = {"formul":"SearchBar_formul__2GOs4","input":"SearchBar_input__1-DF_","boton":"SearchBar_boton__3DxAW"};